/**
 * Default export pour l'auto-discovery `apps/web/src/routes/modules.ts`.
 *
 * Format imposé par `ModuleRoute` (cf. modules.ts ligne 14-26) :
 *   { path, label, icon, element, children? }
 *
 * Le shell prend `element` et l'utilise dans <Outlet />. On lazy-load la page
 * pour ne pas charger TanStack Query + recharts dans le bundle initial.
 */

import { lazy, Suspense, type ReactNode } from 'react';
import type { ModuleRoute } from "@herbo/module-route";

const KpiEntrepot = lazy(() => import('./pages/KpiEntrepot'));
const SerieSachets = lazy(() => import('./pages/SerieSachets'));

function withSuspense(node: ReactNode): ReactNode {
  return (
    <Suspense fallback={<KpiEntrepotFallback />}>{node}</Suspense>
  );
}

function KpiEntrepotFallback(): JSX.Element {
  return (
    <div className="px-6 py-8 text-sm text-slate-500">
      Chargement du module KPI Entrepôt…
    </div>
  );
}

const route: ModuleRoute = {
  path: 'kpi-entrepot',
  label: 'KPI Entrepôt',
  icon: 'bar-chart-3',
  element: withSuspense(<KpiEntrepot />),
};

/**
 * Détail d'une série ouverte (onglet « Sachets », niveau 3) — route CACHÉE
 * (`hidden: true`), même pattern que `herbo-conditionnement/web/route.tsx` :
 * atteinte depuis le tableau des séries en cours, jamais via la TopBar.
 */
const serieSachetsRoute: ModuleRoute = {
  path: 'kpi-entrepot/sachets/serie/:id',
  label: 'KPI Entrepôt',
  icon: 'bar-chart-3',
  hidden: true,
  element: withSuspense(<SerieSachets />),
};

export default [route, serieSachetsRoute];
